/* eslint-disable */
const CRYPTO = function() {
    function r(r) {
        if (r.length < 16 && r.length / 16 != parseInt(r.length / 16, 10)) return r;
        for (var e, a, n, s = "7c825468", c = "8530114a", f = "9305cb7a", o = r.length, t = "", b = (e = C(s)).length, k = (a = C(c)).length, u = (n = C(f)).length, i = parseInt(o / 16), w = 0, w = 0; w < i; w++) {
            for (var A, v, y, g, h = function(r) {
                for (var e = "", a = 0; a < 16; a++) e += function(r) {
                    var e;
                    switch (r) {
                        case"0":
                            e = "0000";
                            break;
                        case"1":
                            e = "0001";
                            break;
                        case"2":
                            e = "0010";
                            break;
                        case"3":
                            e = "0011";
                            break;
                        case"4":
                            e = "0100";
                            break;
                        case"5":
                            e = "0101";
                            break;
                        case"6":
                            e = "0110";
                            break;
                        case"7":
                            e = "0111";
                            break;
                        case"8":
                            e = "1000";
                            break;
                        case"9":
                            e = "1001";
                            break;
                        case"A":
                            e = "1010";
                            break;
                        case"B":
                            e = "1011";
                            break;
                        case"C":
                            e = "1100";
                            break;
                        case"D":
                            e = "1101";
                            break;
                        case"E":
                            e = "1110";
                            break;
                        case"F":
                            e = "1111"
                    }
                    return e
                }(r.substring(a, a + 1));
                return e
            }(r.substring(16 * w + 0, 16 * w + 16)), l = new Array(64), p = 0, p = 0; p < 64; p++) l[p] = parseInt(h.substring(p, p + 1));
            for (f, A = l, v = u - 1; 0 <= v; v--) A = M(A, n[v]);
            for (y = k - 1; 0 <= y; y--) A = M(A, a[y]);
            for (g = b - 1; 0 <= g; g--) A = M(A, e[g]);
            t += function(r) {
                for (var e = "", a = 0; a < 4; a++) {
                    for (var n = 0, s = 0; s < 16; s++) {
                        for (var c = 1, f = 15; s < f; f--) c *= 2;
                        n += r[16 * a + s] * c
                    }
                    0 != n && (e += String.fromCharCode(n))
                }
                return e
            }(A)
        }
        return t
    }

    function C(r) {
        for (var e = new Array, a = r.length, n = parseInt(a / 4), s = a % 4, c = 0, c = 0; c < n; c++) e[c] = p(r.substring(4 * c + 0, 4 * c + 4));
        return 0 < s && (e[c] = p(r.substring(4 * c + 0, a))), e
    }

    function p(r) {
        var e = r.length, a = new Array(64);
        if (e < 4) {
            for (var n = 0, s = 0, c = 0, f = 0, n = 0; n < e; n++) for (var o = r.charCodeAt(n), s = 0; s < 16; s++) {
                var t = 1, b = 0;
                for (b = 15; s < b; b--) t *= 2;
                a[16 * n + s] = parseInt(o / t) % 2
            }
            for (c = e; c < 4; c++) for (o = 0, f = 0; f < 16; f++) {
                t = 1, b = 0;
                for (b = 15; f < b; b--) t *= 2;
                a[16 * c + f] = parseInt(o / t) % 2
            }
        } else for (n = 0; n < 4; n++) {
            o = r.charCodeAt(n);
            for (s = 0; s < 16; s++) {
                t = 1;
                for (b = 15; s < b; b--) t *= 2;
                a[16 * n + s] = parseInt(o / t) % 2
            }
        }
        return a
    }

    function I(r) {
        for (var e = "", a = 0; a < 16; a++) {
            for (var n = "", s = 0; s < 4; s++) n += r[4 * a + s];
            e += function(r) {
                var e;
                switch (r) {
                    case"0000":
                        e = "0";
                        break;
                    case"0001":
                        e = "1";
                        break;
                    case"0010":
                        e = "2";
                        break;
                    case"0011":
                        e = "3";
                        break;
                    case"0100":
                        e = "4";
                        break;
                    case"0101":
                        e = "5";
                        break;
                    case"0110":
                        e = "6";
                        break;
                    case"0111":
                        e = "7";
                        break;
                    case"1000":
                        e = "8";
                        break;
                    case"1001":
                        e = "9";
                        break;
                    case"1010":
                        e = "A";
                        break;
                    case"1011":
                        e = "B";
                        break;
                    case"1100":
                        e = "C";
                        break;
                    case"1101":
                        e = "D";
                        break;
                    case"1110":
                        e = "E";
                        break;
                    case"1111":
                        e = "F"
                }
                return e
            }(n)
        }
        return e
    }

    function d(r, e) {
        for (var a = B(e), n = v(r), s = new Array(32), c = new Array(32), f = new Array(32), o = 0, t = 0, b = 0, k = 0, u = 0, b = 0; b < 32; b++) s[b] = n[b], c[b] = n[32 + b];
        for (o = 0; o < 16; o++) {
            for (t = 0; t < 32; t++) f[t] = s[t], s[t] = c[t];
            for (var i = new Array(48), k = 0; k < 48; k++) i[k] = a[o][k];
            for (var w = g(l(h(g(y(c), i))), f), u = 0; u < 32; u++) c[u] = w[u]
        }
        for (var A = new Array(64), o = 0; o < 32; o++) A[o] = c[o], A[32 + o] = s[o];
        return O(A)
    }

    function M(r, e) {
        for (var a = B(e), n = v(r), s = new Array(32), c = new Array(32), f = new Array(32), o = 0, t = 0, b = 0, k = 0, u = 0, b = 0; b < 32; b++) s[b] = n[b], c[b] = n[32 + b];
        for (o = 15; 0 <= o; o--) {
            for (t = 0; t < 32; t++) f[t] = s[t], s[t] = c[t];
            for (var i = new Array(48), k = 0; k < 48; k++) i[k] = a[o][k];
            for (var w = g(l(h(g(y(c), i))), f), u = 0; u < 32; u++) c[u] = w[u]
        }
        for (var A = new Array(64), o = 0; o < 32; o++) A[o] = c[o], A[32 + o] = s[o];
        return O(A)
    }

    function v(r) {
        for (var e = new Array(64), a = 0, n = 1, s = 0; a < 4; a++, n += 2, s += 2) for (var c = 7, f = 0; 0 <= c; c--, f++) e[8 * a + f] = r[8 * c + n], e[8 * a + f + 32] = r[8 * c + s];
        return e
    }

    function y(r) {
        for (var e = new Array(48), a = 0; a < 8; a++) e[6 * a + 0] = 0 == a ? r[31] : r[4 * a - 1], e[6 * a + 1] = r[4 * a + 0], e[6 * a + 2] = r[4 * a + 1], e[6 * a + 3] = r[4 * a + 2], e[6 * a + 4] = r[4 * a + 3], e[6 * a + 5] = 7 == a ? r[0] : r[4 * a + 4];
        return e
    }

    function g(r, e) {
        for (var a = new Array(r.length), n = 0; n < r.length; n++) a[n] = r[n] ^ e[n];
        return a
    }

    function h(r) {
        for (var e = new Array(32), a = "", n = [[14, 4, 13, 1, 2, 15, 11, 8, 3, 10, 6, 12, 5, 9, 0, 7], [0, 15, 7, 4, 14, 2, 13, 1, 10, 6, 12, 11, 9, 5, 3, 8], [4, 1, 14, 8, 13, 6, 2, 11, 15, 12, 9, 7, 3, 10, 5, 0], [15, 12, 8, 2, 4, 9, 1, 7, 5, 11, 3, 14, 10, 0, 6, 13]], s = [[15, 1, 8, 14, 6, 11, 3, 4, 9, 7, 2, 13, 12, 0, 5, 10], [3, 13, 4, 7, 15, 2, 8, 14, 12, 0, 1, 10, 6, 9, 11, 5], [0, 14, 7, 11, 10, 4, 13, 1, 5, 8, 12, 6, 9, 3, 2, 15], [13, 8, 10, 1, 3, 15, 4, 2, 11, 6, 7, 12, 0, 5, 14, 9]], c = [[10, 0, 9, 14, 6, 3, 15, 5, 1, 13, 12, 7, 11, 4, 2, 8], [13, 7, 0, 9, 3, 4, 6, 10, 2, 8, 5, 14, 12, 11, 15, 1], [13, 6, 4, 9, 8, 15, 3, 0, 11, 1, 2, 12, 5, 10, 14, 7], [1, 10, 13, 0, 6, 9, 8, 7, 4, 15, 14, 3, 11, 5, 2, 12]], f = [[7, 13, 14, 3, 0, 6, 9, 10, 1, 2, 8, 5, 11, 12, 4, 15], [13, 8, 11, 5, 6, 15, 0, 3, 4, 7, 2, 12, 1, 10, 14, 9], [10, 6, 9, 0, 12, 11, 7, 13, 15, 1, 3, 14, 5, 2, 8, 4], [3, 15, 0, 6, 10, 1, 13, 8, 9, 4, 5, 11, 12, 7, 2, 14]], o = [[2, 12, 4, 1, 7, 10, 11, 6, 8, 5, 3, 15, 13, 0, 14, 9], [14, 11, 2, 12, 4, 7, 13, 1, 5, 0, 15, 10, 3, 9, 8, 6], [4, 2, 1, 11, 10, 13, 7, 8, 15, 9, 12, 5, 6, 3, 0, 14], [11, 8, 12, 7, 1, 14, 2, 13, 6, 15, 0, 9, 10, 4, 5, 3]], t = [[12, 1, 10, 15, 9, 2, 6, 8, 0, 13, 3, 4, 14, 7, 5, 11], [10, 15, 4, 2, 7, 12, 9, 5, 6, 1, 13, 14, 0, 11, 3, 8], [9, 14, 15, 5, 2, 8, 12, 3, 7, 0, 4, 10, 1, 13, 11, 6], [4, 3, 2, 12, 9, 5, 15, 10, 11, 14, 1, 7, 6, 0, 8, 13]], b = [[4, 11, 2, 14, 15, 0, 8, 13, 3, 12, 9, 7, 5, 10, 6, 1], [13, 0, 11, 7, 4, 9, 1, 10, 14, 3, 5, 12, 2, 15, 8, 6], [1, 4, 11, 13, 12, 3, 7, 14, 10, 15, 6, 8, 0, 5, 9, 2], [6, 11, 13, 8, 1, 4, 10, 7, 9, 5, 0, 15, 14, 2, 3, 12]], k = [[13, 2, 8, 4, 6, 15, 11, 1, 10, 9, 3, 14, 5, 0, 12, 7], [1, 15, 13, 8, 10, 3, 7, 4, 12, 5, 6, 11, 0, 14, 9, 2], [7, 11, 4, 1, 9, 12, 14, 2, 0, 6, 10, 13, 15, 3, 5, 8], [2, 1, 14, 7, 4, 10, 8, 13, 15, 12, 9, 0, 3, 5, 6, 11]], u = 0; u < 8; u++) {
            var i = 2 * r[6 * u + 0] + r[6 * u + 5],
                w = 2 * r[6 * u + 1] * 2 * 2 + 2 * r[6 * u + 2] * 2 + 2 * r[6 * u + 3] + r[6 * u + 4];
            switch (u) {
                case 0:
                    a = A(n[i][w]);
                    break;
                case 1:
                    a = A(s[i][w]);
                    break;
                case 2:
                    a = A(c[i][w]);
                    break;
                case 3:
                    a = A(f[i][w]);
                    break;
                case 4:
                    a = A(o[i][w]);
                    break;
                case 5:
                    a = A(t[i][w]);
                    break;
                case 6:
                    a = A(b[i][w]);
                    break;
                case 7:
                    a = A(k[i][w])
            }
            e[4 * u + 0] = parseInt(a.substring(0, 1)), e[4 * u + 1] = parseInt(a.substring(1, 2)), e[4 * u + 2] = parseInt(a.substring(2, 3)), e[4 * u + 3] = parseInt(a.substring(3, 4))
        }
        return e
    }

    function l(r) {
        var e = new Array(32);
        return e[0] = r[15], e[1] = r[6], e[2] = r[19], e[3] = r[20], e[4] = r[28], e[5] = r[11], e[6] = r[27], e[7] = r[16], e[8] = r[0], e[9] = r[14], e[10] = r[22], e[11] = r[25], e[12] = r[4], e[13] = r[17], e[14] = r[30], e[15] = r[9], e[16] = r[1], e[17] = r[7], e[18] = r[23], e[19] = r[13], e[20] = r[31], e[21] = r[26], e[22] = r[2], e[23] = r[8], e[24] = r[18], e[25] = r[12], e[26] = r[29], e[27] = r[5], e[28] = r[21], e[29] = r[10], e[30] = r[3], e[31] = r[24], e
    }

    function O(r) {
        var e = new Array(64);
        return e[0] = r[39], e[1] = r[7], e[2] = r[47], e[3] = r[15], e[4] = r[55], e[5] = r[23], e[6] = r[63], e[7] = r[31], e[8] = r[38], e[9] = r[6], e[10] = r[46], e[11] = r[14], e[12] = r[54], e[13] = r[22], e[14] = r[62], e[15] = r[30], e[16] = r[37], e[17] = r[5], e[18] = r[45], e[19] = r[13], e[20] = r[53], e[21] = r[21], e[22] = r[61], e[23] = r[29], e[24] = r[36], e[25] = r[4], e[26] = r[44], e[27] = r[12], e[28] = r[52], e[29] = r[20], e[30] = r[60], e[31] = r[28], e[32] = r[35], e[33] = r[3], e[34] = r[43], e[35] = r[11], e[36] = r[51], e[37] = r[19], e[38] = r[59], e[39] = r[27], e[40] = r[34], e[41] = r[2], e[42] = r[42], e[43] = r[10], e[44] = r[50], e[45] = r[18], e[46] = r[58], e[47] = r[26], e[48] = r[33], e[49] = r[1], e[50] = r[41], e[51] = r[9], e[52] = r[49], e[53] = r[17], e[54] = r[57], e[55] = r[25], e[56] = r[32], e[57] = r[0], e[58] = r[40], e[59] = r[8], e[60] = r[48], e[61] = r[16], e[62] = r[56], e[63] = r[24], e
    }

    function A(r) {
        var e = "";
        switch (r) {
            case 0:
                e = "0000";
                break;
            case 1:
                e = "0001";
                break;
            case 2:
                e = "0010";
                break;
            case 3:
                e = "0011";
                break;
            case 4:
                e = "0100";
                break;
            case 5:
                e = "0101";
                break;
            case 6:
                e = "0110";
                break;
            case 7:
                e = "0111";
                break;
            case 8:
                e = "1000";
                break;
            case 9:
                e = "1001";
                break;
            case 10:
                e = "1010";
                break;
            case 11:
                e = "1011";
                break;
            case 12:
                e = "1100";
                break;
            case 13:
                e = "1101";
                break;
            case 14:
                e = "1110";
                break;
            case 15:
                e = "1111"
        }
        return e
    }

    function B(r) {
        var e = new Array(56), a = new Array;
        a[0] = new Array, a[1] = new Array, a[2] = new Array, a[3] = new Array, a[4] = new Array, a[5] = new Array, a[6] = new Array, a[7] = new Array, a[8] = new Array, a[9] = new Array, a[10] = new Array, a[11] = new Array, a[12] = new Array, a[13] = new Array, a[14] = new Array, a[15] = new Array;
        for (var n = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1], s = 0; s < 7; s++) for (var c = 0, f = 7; c < 8; c++, f--) e[8 * s + c] = r[8 * f + s];
        s = 0;
        for (s = 0; s < 16; s++) {
            for (var o = 0, t = 0, c = 0; c < n[s]; c++) {
                for (o = e[0], t = e[28], f = 0; f < 27; f++) e[f] = e[f + 1], e[28 + f] = e[29 + f];
                e[27] = o, e[55] = t
            }
            var b, k = new Array(48);
            switch (k[0] = e[13], k[1] = e[16], k[2] = e[10], k[3] = e[23], k[4] = e[0], k[5] = e[4], k[6] = e[2], k[7] = e[27], k[8] = e[14], k[9] = e[5], k[10] = e[20], k[11] = e[9], k[12] = e[22], k[13] = e[18], k[14] = e[11], k[15] = e[3], k[16] = e[25], k[17] = e[7], k[18] = e[15], k[19] = e[6], k[20] = e[26], k[21] = e[19], k[22] = e[12], k[23] = e[1], k[24] = e[40], k[25] = e[51], k[26] = e[30], k[27] = e[36], k[28] = e[46], k[29] = e[54], k[30] = e[29], k[31] = e[39], k[32] = e[50], k[33] = e[44], k[34] = e[32], k[35] = e[47], k[36] = e[43], k[37] = e[48], k[38] = e[38], k[39] = e[55], k[40] = e[33], k[41] = e[52], k[42] = e[45], k[43] = e[41], k[44] = e[49], k[45] = e[35], k[46] = e[28], k[47] = e[31], s) {
                case 0:
                    for (b = 0; b < 48; b++) a[0][b] = k[b];
                    break;
                case 1:
                    for (b = 0; b < 48; b++) a[1][b] = k[b];
                    break;
                case 2:
                    for (b = 0; b < 48; b++) a[2][b] = k[b];
                    break;
                case 3:
                    for (b = 0; b < 48; b++) a[3][b] = k[b];
                    break;
                case 4:
                    for (b = 0; b < 48; b++) a[4][b] = k[b];
                    break;
                case 5:
                    for (b = 0; b < 48; b++) a[5][b] = k[b];
                    break;
                case 6:
                    for (b = 0; b < 48; b++) a[6][b] = k[b];
                    break;
                case 7:
                    for (b = 0; b < 48; b++) a[7][b] = k[b];
                    break;
                case 8:
                    for (b = 0; b < 48; b++) a[8][b] = k[b];
                    break;
                case 9:
                    for (b = 0; b < 48; b++) a[9][b] = k[b];
                    break;
                case 10:
                    for (b = 0; b < 48; b++) a[10][b] = k[b];
                    break;
                case 11:
                    for (b = 0; b < 48; b++) a[11][b] = k[b];
                    break;
                case 12:
                    for (b = 0; b < 48; b++) a[12][b] = k[b];
                    break;
                case 13:
                    for (b = 0; b < 48; b++) a[13][b] = k[b];
                    break;
                case 14:
                    for (b = 0; b < 48; b++) a[14][b] = k[b];
                    break;
                case 15:
                    for (b = 0; b < 48; b++) a[15][b] = k[b]
            }
        }
        return a
    }

    return {
        encrypt: function(r) {
            var e, a, n, s = "7c825468", c = "8530114a", f = "9305cb7a", o = r.length, t = "", b = (e = C(s)).length,
                k = (a = C(c)).length, u = (n = C(f)).length;
            if (0 < o) if (o < 4) {
                var i = p(r);
                for (f, w = i, A = 0; A < b; A++) w = d(w, e[A]);
                for (v = 0; v < k; v++) w = d(w, a[v]);
                for (y = 0; y < u; y++) w = d(w, n[y]);
                t = I(w)
            } else {
                for (var w, A, v, y, g = parseInt(o / 4), h = o % 4, l = 0, l = 0; l < g; l++) {
                    for (f, w = p(r.substring(4 * l + 0, 4 * l + 4)), A = 0; A < b; A++) w = d(w, e[A]);
                    for (v = 0; v < k; v++) w = d(w, a[v]);
                    for (y = 0; y < u; y++) w = d(w, n[y]);
                    t += I(w)
                }
                if (0 < h) {
                    for (f, w = p(r.substring(4 * g + 0, o)), A = 0; A < b; A++) w = d(w, e[A]);
                    for (v = 0; v < k; v++) w = d(w, a[v]);
                    for (y = 0; y < u; y++) w = d(w, n[y]);
                    t += I(w)
                }
            }
            return t
        }, decrypt: r
    }
}();

//window.CRYPTO = CRYPTO;

export default  CRYPTO;
